module.exports = __webpack_public_path__ + "img/header.214a19a0.png";